var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftColumnDottedBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 947,
    viewBox: "0 0 372 947",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_10116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.126 271.959C369.126 272.096 369.236 272.212 369.374 272.212C369.512 272.212 369.622 272.102 369.622 271.959C369.622 271.816 369.512 271.711 369.374 271.711C369.236 271.711 369.126 271.821 369.126 271.959Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.13 316.954C368.13 317.641 368.691 318.202 369.379 318.202C370.068 318.202 370.629 317.647 370.629 316.954C370.629 316.261 370.068 315.705 369.379 315.705C368.691 315.705 368.13 316.261 368.13 316.954Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.381 361.948C367.381 363.048 368.278 363.945 369.38 363.945C370.481 363.945 371.378 363.048 371.378 361.948C371.378 360.848 370.481 359.952 369.38 359.952C368.278 359.952 367.381 360.843 367.381 361.948Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.88 406.943C366.88 408.323 367.998 409.44 369.38 409.44C370.761 409.44 371.879 408.323 371.879 406.943C371.879 405.562 370.761 404.446 369.38 404.446C367.998 404.446 366.88 405.562 366.88 406.943Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.753 451.938C366.753 453.384 367.926 454.556 369.374 454.556C370.822 454.556 371.995 453.384 371.995 451.938C371.995 450.491 370.822 449.32 369.374 449.32C367.926 449.32 366.753 450.491 366.753 451.938Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.88 496.932C366.88 498.313 367.998 499.429 369.38 499.429C370.761 499.429 371.879 498.313 371.879 496.932C371.879 495.552 370.761 494.441 369.38 494.441C367.998 494.441 366.88 495.557 366.88 496.932Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.254 541.927C367.254 543.098 368.207 544.05 369.379 544.05C370.552 544.05 371.505 543.098 371.505 541.927C371.505 540.756 370.552 539.804 369.379 539.804C368.207 539.804 367.254 540.756 367.254 541.927Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.876 586.922C367.876 587.747 368.548 588.418 369.374 588.418C370.2 588.418 370.871 587.747 370.871 586.922C370.871 586.097 370.2 585.426 369.374 585.426C368.548 585.426 367.876 586.097 367.876 586.922Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.752 631.916C368.752 632.263 369.033 632.538 369.374 632.538C369.715 632.538 369.996 632.257 369.996 631.916C369.996 631.575 369.715 631.295 369.374 631.295C369.033 631.295 368.752 631.575 368.752 631.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.341 182.096C324.412 182.096 324.468 182.041 324.468 181.97C324.468 181.898 324.412 181.843 324.341 181.843C324.269 181.843 324.214 181.898 324.214 181.97C324.214 182.041 324.269 182.096 324.341 182.096Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.717 226.964C322.717 227.861 323.444 228.587 324.341 228.587C325.238 228.587 325.965 227.861 325.965 226.964C325.965 226.068 325.238 225.342 324.341 225.342C323.444 225.342 322.717 226.068 322.717 226.964Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.467 271.959C321.467 273.543 322.755 274.83 324.341 274.83C325.926 274.83 327.215 273.543 327.215 271.959C327.215 270.375 325.926 269.088 324.341 269.088C322.755 269.088 321.467 270.37 321.467 271.959Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.344 316.954C320.344 319.159 322.133 320.947 324.341 320.947C326.548 320.947 328.338 319.159 328.338 316.954C328.338 314.748 326.548 312.961 324.341 312.961C322.133 312.961 320.344 314.748 320.344 316.954Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.595 361.948C319.595 364.566 321.72 366.689 324.341 366.689C326.961 366.689 329.086 364.566 329.086 361.948C329.086 359.33 326.961 357.207 324.341 357.207C321.72 357.207 319.595 359.33 319.595 361.948Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.094 406.943C319.094 409.836 321.445 412.184 324.341 412.184C327.237 412.184 329.587 409.841 329.587 406.943C329.587 404.045 327.237 401.702 324.341 401.702C321.445 401.702 319.094 404.05 319.094 406.943Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.847 451.938C318.847 454.968 321.307 457.427 324.341 457.427C327.374 457.427 329.835 454.968 329.835 451.938C329.835 448.907 327.374 446.449 324.341 446.449C321.307 446.449 318.847 448.907 318.847 451.938Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.968 496.932C318.968 499.897 321.374 502.295 324.335 502.295C327.297 502.295 329.703 499.891 329.703 496.932C329.703 493.973 327.297 491.57 324.335 491.57C321.374 491.57 318.968 493.973 318.968 496.932Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.342 541.927C319.342 544.682 321.577 546.921 324.335 546.921C327.093 546.921 329.329 544.688 329.329 541.927C329.329 539.166 327.093 536.939 324.335 536.939C321.577 536.939 319.342 539.172 319.342 541.927Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.091 586.922C320.091 589.265 321.99 591.162 324.335 591.162C326.681 591.162 328.58 589.259 328.58 586.922C328.58 584.584 326.681 582.681 324.335 582.681C321.99 582.681 320.091 584.579 320.091 586.922Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.093 631.916C321.093 633.709 322.546 635.161 324.341 635.161C326.136 635.161 327.589 633.709 327.589 631.916C327.589 630.123 326.136 628.671 324.341 628.671C322.546 628.671 321.093 630.123 321.093 631.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.216 676.911C322.216 678.083 323.168 679.034 324.341 679.034C325.513 679.034 326.466 678.083 326.466 676.911C326.466 675.74 325.513 674.788 324.341 674.788C323.168 674.788 322.216 675.74 322.216 676.911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.713 721.906C323.713 722.252 323.994 722.527 324.335 722.527C324.677 722.527 324.957 722.247 324.957 721.906C324.957 721.565 324.677 721.284 324.335 721.284C323.994 721.284 323.713 721.565 323.713 721.906Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.675 136.98C278.675 137.327 278.955 137.607 279.297 137.607C279.638 137.607 279.919 137.327 279.919 136.98C279.919 136.634 279.638 136.359 279.297 136.359C278.955 136.359 278.675 136.639 278.675 136.98Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.803 181.975C276.803 183.35 277.92 184.472 279.302 184.472C280.684 184.472 281.802 183.356 281.802 181.975C281.802 180.595 280.684 179.478 279.302 179.478C277.92 179.478 276.803 180.595 276.803 181.975Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.179 226.964C275.179 229.239 277.025 231.084 279.302 231.084C281.58 231.084 283.426 229.239 283.426 226.964C283.426 224.689 281.58 222.845 279.302 222.845C277.025 222.845 275.179 224.689 275.179 226.964Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.808 271.959C273.808 274.989 276.269 277.448 279.302 277.448C282.336 277.448 284.797 274.989 284.797 271.959C284.797 268.929 282.336 266.47 279.302 266.47C276.269 266.47 273.808 268.929 273.808 271.959Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.679 316.954C272.679 320.606 275.641 323.565 279.297 323.565C282.952 323.565 285.914 320.606 285.914 316.954C285.914 313.302 282.952 310.343 279.297 310.343C275.641 310.343 272.679 313.302 272.679 316.954Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.683 361.948C271.683 366.15 275.096 369.56 279.302 369.56C283.508 369.56 286.922 366.15 286.922 361.948C286.922 357.746 283.508 354.336 279.302 354.336C275.096 354.336 271.683 357.741 271.683 361.948Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.182 406.943C271.182 411.425 274.815 415.055 279.302 415.055C283.789 415.055 287.422 411.425 287.422 406.943C287.422 402.461 283.789 398.836 279.302 398.836C274.815 398.836 271.182 402.466 271.182 406.943Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.934 451.938C270.934 456.558 274.683 460.297 279.302 460.297C283.921 460.297 287.67 456.558 287.67 451.938C287.67 447.318 283.921 443.578 279.302 443.578C274.683 443.578 270.934 447.318 270.934 451.938Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.183 505.178C283.734 505.243 287.476 501.61 287.541 497.063C287.607 492.516 283.97 488.778 279.419 488.713C274.868 488.648 271.126 492.281 271.06 496.827C270.995 501.374 274.632 505.113 279.183 505.178Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.556 541.927C271.556 546.2 275.025 549.665 279.302 549.665C283.58 549.665 287.043 546.2 287.043 541.927C287.043 537.654 283.574 534.194 279.302 534.194C275.03 534.194 271.556 537.659 271.556 541.927Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.305 586.922C272.305 590.783 275.438 593.907 279.297 593.907C283.156 593.907 286.288 590.777 286.288 586.922C286.288 583.066 283.156 579.937 279.297 579.937C275.438 579.937 272.305 583.066 272.305 586.922Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.434 631.916C273.434 635.156 276.06 637.779 279.302 637.779C282.545 637.779 285.171 635.15 285.171 631.916C285.171 628.682 282.545 626.053 279.302 626.053C276.06 626.053 273.434 628.677 273.434 631.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.678 676.911C274.678 679.463 276.748 681.525 279.297 681.525C281.846 681.525 283.916 679.457 283.916 676.911C283.916 674.365 281.846 672.297 279.297 672.297C276.748 672.297 274.678 674.365 274.678 676.911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.302 721.906C276.302 723.561 277.645 724.898 279.297 724.898C280.948 724.898 282.292 723.556 282.292 721.906C282.292 720.256 280.948 718.914 279.297 718.914C277.645 718.914 276.302 720.256 276.302 721.906Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.052 766.895C278.052 767.582 278.614 768.143 279.302 768.143C279.99 768.143 280.552 767.588 280.552 766.895C280.552 766.202 279.99 765.646 279.302 765.646C278.614 765.646 278.052 766.202 278.052 766.895Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.636 91.9858C233.636 92.3323 233.917 92.6128 234.258 92.6128C234.599 92.6128 234.88 92.3323 234.88 91.9858C234.88 91.6393 234.599 91.3643 234.258 91.3643C233.917 91.3643 233.636 91.6448 233.636 91.9858Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.516 136.98C231.516 138.498 232.744 139.725 234.264 139.725C235.783 139.725 237.011 138.493 237.011 136.98C237.011 135.468 235.783 134.236 234.264 134.236C232.744 134.236 231.516 135.462 231.516 136.98Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.645 181.975C229.645 184.527 231.715 186.59 234.264 186.59C236.813 186.59 238.883 184.522 238.883 181.975C238.883 179.429 236.813 177.361 234.264 177.361C231.715 177.361 229.645 179.429 229.645 181.975Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.767 226.964C227.767 230.55 230.674 233.454 234.264 233.454C237.853 233.454 240.76 230.55 240.76 226.964C240.76 223.378 237.853 220.48 234.264 220.48C230.674 220.48 227.767 223.384 227.767 226.964Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.27 271.959C226.27 276.37 229.848 279.945 234.264 279.945C238.679 279.945 242.257 276.37 242.257 271.959C242.257 267.548 238.679 263.973 234.264 263.973C229.848 263.973 226.27 267.548 226.27 271.959Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.894 316.954C224.894 322.118 229.089 326.309 234.258 326.309C239.428 326.309 243.623 322.118 243.623 316.954C243.623 311.789 239.428 307.593 234.258 307.593C229.089 307.593 224.894 311.784 224.894 316.954Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.897 361.948C223.897 367.668 228.538 372.305 234.264 372.305C239.989 372.305 244.63 367.668 244.63 361.948C244.63 356.228 239.989 351.592 234.264 351.592C228.538 351.592 223.897 356.228 223.897 361.948Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.275 406.943C223.275 413.009 228.197 417.926 234.264 417.926C240.33 417.926 245.252 413.009 245.252 406.943C245.252 400.877 240.33 395.965 234.264 395.965C228.197 395.965 223.275 400.882 223.275 406.943Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.022 451.938C223.022 458.14 228.055 463.168 234.264 463.168C240.472 463.168 245.505 458.14 245.505 451.938C245.505 445.735 240.472 440.707 234.264 440.707C228.055 440.707 223.022 445.735 223.022 451.938Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.148 496.932C223.148 503.065 228.125 508.037 234.264 508.037C240.402 508.037 245.379 503.065 245.379 496.932C245.379 490.8 240.402 485.828 234.264 485.828C228.125 485.828 223.148 490.8 223.148 496.932Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.649 541.927C223.649 547.784 228.401 552.531 234.264 552.531C240.127 552.531 244.878 547.784 244.878 541.927C244.878 536.07 240.127 531.323 234.264 531.323C228.401 531.323 223.649 536.07 223.649 541.927Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.141 596.661C239.519 596.726 243.932 592.424 243.998 587.051C244.064 581.678 239.757 577.269 234.379 577.203C229.001 577.138 224.588 581.44 224.522 586.813C224.456 592.186 228.763 596.595 234.141 596.661Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.769 631.916C225.769 636.602 229.573 640.403 234.264 640.403C238.954 640.403 242.758 636.602 242.758 631.916C242.758 627.23 238.954 623.43 234.264 623.43C229.573 623.43 225.769 627.23 225.769 631.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.266 676.911C227.266 680.772 230.399 683.901 234.258 683.901C238.117 683.901 241.25 680.772 241.25 676.911C241.25 673.05 238.117 669.926 234.258 669.926C230.399 669.926 227.266 673.056 227.266 676.911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.017 721.906C229.017 724.8 231.366 727.147 234.264 727.147C237.161 727.147 239.51 724.8 239.51 721.906C239.51 719.011 237.161 716.664 234.264 716.664C231.366 716.664 229.017 719.011 229.017 721.906Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.889 766.895C230.889 768.754 232.397 770.266 234.264 770.266C236.13 770.266 237.638 768.759 237.638 766.895C237.638 765.03 236.13 763.523 234.264 763.523C232.397 763.523 230.889 765.03 230.889 766.895Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.887 811.889C232.887 812.648 233.504 813.264 234.264 813.264C235.023 813.264 235.64 812.648 235.64 811.889C235.64 811.131 235.023 810.52 234.264 810.52C233.504 810.52 232.887 811.136 232.887 811.889Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.225 47.1121C189.297 47.1121 189.352 47.0571 189.352 46.9856C189.352 46.9141 189.297 46.8591 189.225 46.8591C189.153 46.8591 189.098 46.9141 189.098 46.9856C189.098 47.0571 189.153 47.1121 189.225 47.1121Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.726 91.9858C186.726 93.3663 187.843 94.4827 189.225 94.4827C190.607 94.4827 191.724 93.3663 191.724 91.9858C191.724 90.6053 190.607 89.4943 189.225 89.4943C187.843 89.4943 186.726 90.6108 186.726 91.9858Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.606 136.98C184.606 139.532 186.676 141.595 189.225 141.595C191.774 141.595 193.844 139.527 193.844 136.98C193.844 134.434 191.774 132.366 189.225 132.366C186.676 132.366 184.606 134.434 184.606 136.98Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.481 181.975C182.481 185.699 185.498 188.713 189.225 188.713C192.952 188.713 195.969 185.699 195.969 181.975C195.969 178.252 192.952 175.238 189.225 175.238C185.498 175.238 182.481 178.252 182.481 181.975Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.483 226.964C180.483 231.788 184.397 235.698 189.225 235.698C194.053 235.698 197.967 231.788 197.967 226.964C197.967 222.141 194.053 218.23 189.225 218.23C184.397 218.23 180.483 222.141 180.483 226.964Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.732 271.959C178.732 277.745 183.428 282.442 189.225 282.442C195.022 282.442 199.718 277.75 199.718 271.959C199.718 266.168 195.022 261.476 189.225 261.476C183.428 261.476 178.732 266.168 178.732 271.959Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.26 317.322C177.459 323.934 182.986 329.134 189.605 328.935C196.224 328.737 201.429 323.215 201.231 316.603C201.032 309.99 195.505 304.79 188.886 304.989C182.266 305.187 177.062 310.709 177.26 317.322Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.112 361.948C176.112 369.186 181.98 375.049 189.225 375.049C196.47 375.049 202.339 369.186 202.339 361.948C202.339 354.71 196.47 348.848 189.225 348.848C181.98 348.848 176.112 354.71 176.112 361.948Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.363 406.943C175.363 414.593 181.567 420.792 189.225 420.792C196.883 420.792 203.087 414.593 203.087 406.943C203.087 399.293 196.883 393.094 189.225 393.094C181.567 393.094 175.363 399.293 175.363 406.943Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.683 466.029C196.47 466.327 203.025 460.263 203.324 452.484C203.624 444.704 197.553 438.156 189.766 437.857C181.979 437.558 175.424 443.622 175.125 451.402C174.826 459.181 180.896 465.73 188.683 466.029Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.236 496.932C175.236 504.649 181.501 510.908 189.225 510.908C196.949 510.908 203.214 504.649 203.214 496.932C203.214 489.216 196.949 482.957 189.225 482.957C181.501 482.957 175.236 489.216 175.236 496.932Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.864 541.927C175.864 549.302 181.848 555.275 189.225 555.275C196.602 555.275 202.586 549.297 202.586 541.927C202.586 534.557 196.602 528.579 189.225 528.579C181.848 528.579 175.864 534.557 175.864 541.927Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.793 599.238C195.618 599.48 201.347 594.15 201.59 587.332C201.833 580.514 196.498 574.79 189.674 574.548C182.849 574.305 177.119 579.635 176.876 586.453C176.633 593.271 181.969 598.995 188.793 599.238Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.236 631.916C178.236 637.983 183.158 642.894 189.225 642.894C195.292 642.894 200.214 637.977 200.214 631.916C200.214 625.855 195.292 620.939 189.225 620.939C183.158 620.939 178.236 625.855 178.236 631.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.861 676.911C179.861 682.081 184.056 686.272 189.225 686.272C194.394 686.272 198.589 682.081 198.589 676.911C198.589 671.741 194.394 667.556 189.225 667.556C184.056 667.556 179.861 671.747 179.861 676.911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.732 721.906C181.732 726.04 185.087 729.391 189.225 729.391C193.363 729.391 196.718 726.04 196.718 721.906C196.718 717.772 193.363 714.42 189.225 714.42C185.087 714.42 181.732 717.772 181.732 721.906Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.852 766.895C183.852 769.859 186.258 772.263 189.22 772.263C192.181 772.263 194.587 769.859 194.587 766.895C194.587 763.93 192.181 761.532 189.22 761.532C186.258 761.532 183.852 763.936 183.852 766.895Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.977 811.889C185.977 813.682 187.43 815.134 189.225 815.134C191.02 815.134 192.473 813.682 192.473 811.889C192.473 810.097 191.02 808.645 189.225 808.645C187.43 808.645 185.977 810.097 185.977 811.889Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.35 856.884C188.35 857.368 188.741 857.759 189.225 857.759C189.709 857.759 190.1 857.368 190.1 856.884C190.1 856.4 189.709 856.01 189.225 856.01C188.741 856.01 188.35 856.4 188.35 856.884Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.562 46.9911C142.562 47.8876 143.289 48.6136 144.186 48.6136C145.084 48.6136 145.811 47.8876 145.811 46.9911C145.811 46.0946 145.084 45.3687 144.186 45.3687C143.289 45.3687 142.562 46.0946 142.562 46.9911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.063 91.9858C140.063 94.2609 141.909 96.1052 144.186 96.1052C146.464 96.1052 148.31 94.2609 148.31 91.9858C148.31 89.7107 146.464 87.8664 144.186 87.8664C141.909 87.8664 140.063 89.7107 140.063 91.9858Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69 136.98C137.69 140.566 140.597 143.47 144.186 143.47C147.776 143.47 150.683 140.566 150.683 136.98C150.683 133.395 147.776 130.496 144.186 130.496C140.597 130.496 137.69 133.4 137.69 136.98Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.444 181.975C135.444 186.799 139.358 190.709 144.186 190.709C149.014 190.709 152.929 186.799 152.929 181.975C152.929 177.152 149.014 173.241 144.186 173.241C139.358 173.241 135.444 177.152 135.444 181.975Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.319 226.964C133.319 232.959 138.186 237.821 144.186 237.821C150.187 237.821 155.054 232.965 155.054 226.964C155.054 220.964 150.187 216.107 144.186 216.107C138.186 216.107 133.319 220.969 133.319 226.964Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.447 271.959C131.447 278.988 137.151 284.686 144.186 284.686C151.222 284.686 156.926 278.988 156.926 271.959C156.926 264.93 151.222 259.232 144.186 259.232C137.151 259.232 131.447 264.93 131.447 271.959Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.697 316.954C129.697 324.948 136.184 331.429 144.186 331.429C152.189 331.429 158.676 324.948 158.676 316.954C158.676 308.959 152.189 302.478 144.186 302.478C136.184 302.478 129.697 308.959 129.697 316.954Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.453 362.594C128.813 371.267 136.144 378.007 144.827 377.646C153.509 377.286 160.254 369.962 159.894 361.288C159.533 352.614 152.202 345.875 143.52 346.236C134.838 346.596 128.092 353.92 128.453 362.594Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.577 406.943C127.577 416.106 135.014 423.536 144.186 423.536C153.358 423.536 160.796 416.106 160.796 406.943C160.796 397.78 153.358 390.35 144.186 390.35C135.014 390.35 127.577 397.78 127.577 406.943Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.203 451.938C127.203 461.309 134.805 468.905 144.186 468.905C153.567 468.905 161.17 461.309 161.17 451.938C161.17 442.566 153.567 434.97 144.186 434.97C134.805 434.97 127.203 442.566 127.203 451.938Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.324 496.932C127.324 506.238 134.871 513.778 144.186 513.778C153.501 513.778 161.043 506.238 161.043 496.932C161.043 487.626 153.496 480.092 144.186 480.092C134.877 480.092 127.324 487.632 127.324 496.932Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.078 541.927C128.078 550.815 135.29 558.02 144.186 558.02C153.083 558.02 160.295 550.815 160.295 541.927C160.295 533.039 153.083 525.834 144.186 525.834C135.29 525.834 128.078 533.039 128.078 541.927Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.363 587.122C129.466 595.323 136.204 601.887 144.413 601.784C152.622 601.681 159.193 594.95 159.089 586.749C158.986 578.549 152.248 571.984 144.04 572.087C135.831 572.19 129.26 578.922 129.363 587.122Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.825 631.916C130.825 639.292 136.809 645.265 144.186 645.265C151.563 645.265 157.548 639.286 157.548 631.916C157.548 624.546 151.563 618.568 144.186 618.568C136.809 618.568 130.825 624.546 130.825 631.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.697 676.911C132.697 683.252 137.839 688.389 144.186 688.389C150.534 688.389 155.676 683.252 155.676 676.911C155.676 670.57 150.534 665.433 144.186 665.433C137.839 665.433 132.697 670.57 132.697 676.911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.695 721.906C134.695 727.142 138.945 731.387 144.186 731.387C149.427 731.387 153.677 727.142 153.677 721.906C153.677 716.67 149.427 712.424 144.186 712.424C138.945 712.424 134.695 716.67 134.695 721.906Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.942 766.895C136.942 770.893 140.184 774.133 144.186 774.133C148.189 774.133 151.431 770.893 151.431 766.895C151.431 762.896 148.189 759.657 144.186 759.657C140.184 759.657 136.942 762.896 136.942 766.895Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.314 811.889C139.314 814.579 141.494 816.757 144.186 816.757C146.879 816.757 149.059 814.579 149.059 811.889C149.059 809.2 146.879 807.022 144.186 807.022C141.494 807.022 139.314 809.2 139.314 811.889Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.687 856.884C141.687 858.259 142.805 859.381 144.186 859.381C145.568 859.381 146.686 858.265 146.686 856.884C146.686 855.504 145.568 854.387 144.186 854.387C142.805 854.387 141.687 855.504 141.687 856.884Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9 1.99646C98.9 2.13396 99.0101 2.24945 99.1478 2.24945C99.2854 2.24945 99.3955 2.13946 99.3955 1.99646C99.3955 1.85346 99.2854 1.74896 99.1478 1.74896C99.0101 1.74896 98.9 1.85896 98.9 1.99646Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.274 46.9911C96.274 48.5751 97.5622 49.8621 99.1477 49.8621C100.733 49.8621 102.021 48.5806 102.021 46.9911C102.021 45.4017 100.733 44.1202 99.1477 44.1202C97.5622 44.1202 96.274 45.4072 96.274 46.9911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6536 91.9858C93.6536 95.0162 96.1144 97.4747 99.1478 97.4747C102.181 97.4747 104.642 95.0162 104.642 91.9858C104.642 88.9553 102.181 86.4969 99.1478 86.4969C96.1144 86.4969 93.6536 88.9553 93.6536 91.9858Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.154 136.98C91.154 141.391 94.7325 144.966 99.1477 144.966C103.563 144.966 107.141 141.391 107.141 136.98C107.141 132.57 103.563 128.995 99.1477 128.995C94.7325 128.995 91.154 132.57 91.154 136.98Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6602 181.975C88.6601 187.761 93.3561 192.458 99.1532 192.458C104.95 192.458 109.646 187.767 109.646 181.975C109.646 176.184 104.95 171.492 99.1532 171.492C93.3561 171.492 88.6602 176.184 88.6602 181.975Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4086 226.964C86.4086 233.993 92.1121 239.691 99.1478 239.691C106.183 239.691 111.887 233.993 111.887 226.964C111.887 219.936 106.183 214.238 99.1478 214.238C92.1121 214.238 86.4086 219.936 86.4086 226.964Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2891 271.959C84.2891 280.159 90.945 286.809 99.1533 286.809C107.362 286.809 114.018 280.159 114.018 271.959C114.018 263.759 107.362 257.109 99.1533 257.109C90.945 257.109 84.2891 263.759 84.2891 271.959Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2907 316.954C82.2907 326.259 89.8384 333.794 99.1534 333.794C108.468 333.794 116.01 326.254 116.01 316.954C116.01 307.653 108.463 300.107 99.1534 300.107C89.8439 300.107 82.2907 307.648 82.2907 316.954Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8152 363.278C81.5596 373.38 90.3609 380.968 100.474 380.224C110.586 379.48 118.181 370.687 117.436 360.585C116.692 350.482 107.89 342.895 97.7778 343.638C87.6652 344.382 80.0708 353.175 80.8152 363.278Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.504 406.943C118.504 396.262 109.839 387.605 99.1479 387.605C88.4566 387.605 79.7913 396.262 79.7913 406.943C79.7913 417.624 88.4566 426.281 99.1479 426.281C109.839 426.281 118.504 417.624 118.504 406.943Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2903 451.938C79.2903 462.894 88.1809 471.776 99.1479 471.776C110.115 471.776 119.005 462.894 119.005 451.938C119.005 440.981 110.115 432.1 99.1479 432.1C88.1809 432.1 79.2903 440.981 79.2903 451.938Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.538 496.932C79.538 507.752 88.3176 516.523 99.1478 516.523C109.978 516.523 118.758 507.752 118.758 496.932C118.758 486.113 109.978 477.342 99.1478 477.342C88.3176 477.342 79.538 486.113 79.538 496.932Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.882 541.927C117.882 531.593 109.498 523.211 99.1476 523.211C88.7977 523.211 80.4132 531.587 80.4132 541.927C80.4132 552.267 88.7977 560.643 99.1476 560.643C109.498 560.643 117.882 552.267 117.882 541.927Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7896 586.922C81.7896 596.497 89.5631 604.263 99.1477 604.263C108.732 604.263 116.506 596.497 116.506 586.922C116.506 577.346 108.732 569.58 99.1477 569.58C89.5631 569.58 81.7896 577.346 81.7896 586.922Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5349 631.916C83.5349 640.531 90.525 647.514 99.1478 647.514C107.771 647.514 114.761 640.531 114.761 631.916C114.761 623.302 107.771 616.319 99.1478 616.319C90.525 616.319 83.5349 623.302 83.5349 631.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6599 676.911C85.6599 684.352 91.6992 690.386 99.1478 690.386C106.596 690.386 112.636 684.352 112.636 676.911C112.636 669.47 106.596 663.436 99.1478 663.436C91.6992 663.436 85.6599 669.47 85.6599 676.911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9059 721.906C87.9059 728.109 92.9377 733.136 99.1476 733.136C105.358 733.136 110.389 728.109 110.389 721.906C110.389 715.702 105.358 710.675 99.1477 710.675C92.9377 710.675 87.9059 715.702 87.9059 721.906Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2786 766.895C90.2786 771.784 94.2479 775.755 99.1476 775.755C104.047 775.755 108.017 771.79 108.017 766.895C108.017 762 104.047 758.034 99.1476 758.034C94.2479 758.034 90.2786 762 90.2786 766.895Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7781 811.889C92.7781 815.404 95.6299 818.253 99.1477 818.253C102.666 818.253 105.517 815.404 105.517 811.889C105.517 808.375 102.666 805.526 99.1477 805.526C95.6299 805.526 92.7781 808.375 92.7781 811.889Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4042 856.884C95.4042 858.952 97.0833 860.63 99.1533 860.63C101.223 860.63 102.902 858.952 102.902 856.884C102.902 854.816 101.223 853.139 99.1533 853.139C97.0833 853.139 95.4042 854.816 95.4042 856.884Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0246 901.879C98.0246 902.5 98.5256 903.001 99.1477 903.001C99.7698 903.001 100.271 902.495 100.271 901.879C100.271 901.263 99.7698 900.757 99.1477 900.757C98.5256 900.757 98.0246 901.257 98.0246 901.879Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8595 1.99646C52.8595 2.68945 53.421 3.24494 54.1092 3.24494C54.7973 3.24494 55.3589 2.68945 55.3589 1.99646C55.3589 1.30348 54.7973 0.747986 54.1092 0.747986C53.421 0.747986 52.8595 1.30348 52.8595 1.99646Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0124 50.9781C56.2188 51.0439 58.0608 49.3104 58.1267 47.1061C58.1926 44.9019 56.4573 43.0616 54.2509 42.9958C52.0445 42.93 50.2025 44.6636 50.1366 46.8678C50.0707 49.0721 51.806 50.9123 54.0124 50.9781Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4919 91.9858C47.4919 95.6369 50.4546 98.5967 54.1092 98.5967C57.7639 98.5967 60.7266 95.6369 60.7266 91.9858C60.7266 88.3347 57.7639 85.3749 54.1092 85.3749C50.4546 85.3749 47.4919 88.3347 47.4919 91.9858Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7447 136.98C44.7447 142.15 48.9397 146.341 54.1092 146.341C59.2786 146.341 63.4736 142.15 63.4736 136.98C63.4736 131.811 59.2786 127.625 54.1092 127.625C48.9397 127.625 44.7447 131.816 44.7447 136.98Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1187 181.975C42.1187 188.591 47.4863 193.954 54.1091 193.954C60.732 193.954 66.0996 188.591 66.0996 181.975C66.0996 175.359 60.732 169.996 54.1091 169.996C47.4863 169.996 42.1187 175.359 42.1187 181.975Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6194 226.964C39.6194 234.959 46.1067 241.44 54.1092 241.44C62.1118 241.44 68.5991 234.959 68.5991 226.964C68.5991 218.97 62.1118 212.489 54.1092 212.489C46.1067 212.489 39.6194 218.97 39.6194 226.964Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.252 271.959C37.252 281.259 44.7997 288.805 54.1146 288.805C63.4296 288.805 70.9773 281.265 70.9773 271.959C70.9773 262.653 63.4296 255.118 54.1146 255.118C44.7997 255.118 37.252 262.659 37.252 271.959Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.127 316.954C35.127 327.425 43.6271 335.917 54.1091 335.917C64.5912 335.917 73.0913 327.425 73.0913 316.954C73.0913 306.482 64.5912 297.99 54.1091 297.99C43.6271 297.99 35.127 306.482 35.127 316.954Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9685 361.948C74.9685 350.443 65.6316 341.115 54.1145 341.115C42.5975 341.115 33.2551 350.442 33.2551 361.948C33.2551 373.454 42.592 382.787 54.1145 382.787C65.6371 382.787 74.9685 373.46 74.9685 361.948Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.719 586.922C73.719 576.103 64.9381 567.331 54.1092 567.331C43.2804 567.331 34.4995 576.103 34.4994 586.922C34.4994 597.74 43.2804 606.507 54.1092 606.507C64.9381 606.507 73.719 597.74 73.719 586.922Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4977 631.916C36.4977 641.633 44.3826 649.51 54.1091 649.51C63.8356 649.51 71.7205 641.633 71.7205 631.916C71.7205 622.199 63.8356 614.322 54.1091 614.322C44.3826 614.322 36.4977 622.199 36.4977 631.916Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8761 676.911C38.8761 685.32 45.6971 692.135 54.1147 692.135C62.5322 692.135 69.3533 685.32 69.3533 676.911C69.3533 668.502 62.5322 661.693 54.1147 661.693C45.6971 661.693 38.8761 668.507 38.8761 676.911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.37 721.906C41.37 728.935 47.0734 734.632 54.1092 734.632C61.1449 734.632 66.8484 728.935 66.8484 721.906C66.8484 714.877 61.1449 709.179 54.1092 709.179C47.0734 709.179 41.37 714.877 41.37 721.906Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8693 766.895C43.8693 772.543 48.4552 777.125 54.1091 777.125C59.763 777.125 64.3489 772.543 64.3489 766.895C64.3489 761.246 59.763 756.665 54.1091 756.665C48.4552 756.665 43.8693 761.246 43.8693 766.895Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4897 811.889C46.4897 816.091 49.903 819.501 54.109 819.501C58.315 819.501 61.7283 816.091 61.7283 811.889C61.7283 807.688 58.315 804.278 54.109 804.278C49.903 804.278 46.4897 807.682 46.4897 811.889Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2369 856.884C49.2369 859.574 51.417 861.752 54.109 861.752C56.8011 861.752 58.9812 859.574 58.9812 856.884C58.9812 854.195 56.8011 852.017 54.109 852.017C51.417 852.017 49.2369 854.195 49.2369 856.884Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9897 901.879C51.9897 903.05 52.9421 904.002 54.1147 904.002C55.2873 904.002 56.2397 903.05 56.2397 901.879C56.2397 900.707 55.2873 899.756 54.1147 899.756C52.9421 899.756 51.9897 900.707 51.9897 901.879Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0688 1.99643C11.0688 0.896453 10.1715 -3.05568e-05 9.07043 -3.06049e-05C7.96938 -3.06531e-05 7.07202 0.896453 7.07202 1.99643C7.07202 3.09641 7.96938 3.9929 9.07043 3.9929C10.1715 3.9929 11.0688 3.09641 11.0688 1.99643Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8162 46.9911C13.8162 44.3732 11.6911 42.2502 9.07062 42.2502C6.45011 42.2502 4.32508 44.3732 4.32508 46.9911C4.32508 49.6091 6.45011 51.732 9.07062 51.732C11.6911 51.732 13.8162 49.6091 13.8162 46.9911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6897 91.9858C16.6897 87.7839 13.2764 84.3739 9.07042 84.3739C4.86439 84.3739 1.45111 87.7784 1.45111 91.9858C1.45111 96.1932 4.86439 99.5976 9.07042 99.5976C13.2764 99.5976 16.6897 96.1877 16.6897 91.9858Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.437 136.98C19.437 131.261 14.7961 126.624 9.07058 126.624C3.34509 126.624 -1.29586 131.261 -1.29586 136.98C-1.29586 142.7 3.34509 147.337 9.07058 147.337C14.7961 147.337 19.437 142.7 19.437 136.98Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1841 181.975C22.1841 174.737 16.3155 168.874 9.07052 168.874C1.82559 168.874 -4.04304 174.737 -4.04304 181.975C-4.04304 189.213 1.82559 195.076 9.07052 195.076C16.3155 195.076 22.1841 189.213 22.1841 181.975Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04776 241.492C11.076 244.814 20.2799 241.006 23.6053 232.985C26.9307 224.965 23.1183 215.77 15.0901 212.448C7.06188 209.126 -2.14206 212.934 -5.46746 220.955C-8.79286 228.975 -4.98046 238.17 3.04776 241.492Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.26678 273.046C-8.66188 283.158 0.0339574 290.865 10.1559 290.261C20.2778 289.657 27.9929 280.969 27.388 270.857C26.7831 260.745 18.0873 253.038 7.96536 253.642C-2.15658 254.246 -9.87167 262.934 -9.26678 273.046Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9299 316.954C29.9299 305.448 20.593 296.115 9.07596 296.115C-2.44106 296.115 -11.778 305.442 -11.778 316.954C-11.778 328.465 -2.44106 337.787 9.07596 337.787C20.593 337.787 29.9299 328.459 29.9299 316.954Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.88888 635.008C-8.18673 645.484 1.69387 652.598 12.18 650.897C22.6662 649.197 29.7871 639.326 28.0849 628.85C26.3828 618.374 16.5022 611.26 6.01603 612.961C-4.47015 614.661 -11.591 624.532 -9.88888 635.008Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6855 676.911C25.6855 667.748 18.2479 660.318 9.07615 660.318C-0.0956268 660.318 -7.53327 667.748 -7.53327 676.911C-7.53327 686.074 -0.0956283 693.504 9.07615 693.504C18.2479 693.504 25.6855 686.074 25.6855 676.911Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0593 721.906C23.0593 714.189 16.7943 707.93 9.07045 707.93C1.34656 707.93 -4.91846 714.189 -4.91846 721.906C-4.91846 729.622 1.34655 735.881 9.07045 735.881C16.7943 735.881 23.0593 729.622 23.0593 721.906Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3123 766.895C20.3123 760.696 15.2804 755.664 9.0705 755.664C2.86056 755.664 -2.17125 760.691 -2.17125 766.895C-2.17125 773.099 2.86055 778.126 9.0705 778.126C15.2804 778.126 20.3123 773.099 20.3123 766.895Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5652 811.889C17.5652 807.204 13.761 803.403 9.07056 803.403C4.38006 803.403 0.575928 807.204 0.575927 811.889C0.575927 816.575 4.38006 820.376 9.07056 820.376C13.761 820.376 17.5652 816.575 17.5652 811.889Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8181 856.884C14.8181 853.716 12.2472 851.148 9.07061 851.148C5.89407 851.148 3.32311 853.716 3.32311 856.884C3.32311 860.052 5.89407 862.621 9.07061 862.621C12.2472 862.621 14.8181 860.052 14.8181 856.884Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9443 901.879C11.9443 900.295 10.6561 899.008 9.0706 899.008C7.48508 899.008 6.19683 900.289 6.19683 901.879C6.19683 903.468 7.48508 904.75 9.0706 904.75C10.6561 904.75 11.9443 903.463 11.9443 901.879Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07041 946.747C8.99884 946.747 8.9438 946.802 8.9438 946.873C8.9438 946.945 8.99884 947 9.07041 947C9.14198 947 9.19702 946.945 9.19702 946.873C9.19702 946.802 9.14198 946.747 9.07041 946.747Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.9837 586.922C-12.9837 577.456 -18.7147 569.339 -26.901 565.824C-20.3828 563.355 -15.1308 558.333 -12.4056 551.948C-8.95935 559.301 -1.87407 564.603 6.54899 565.494C-4.19179 566.748 -12.5323 575.85 -12.5323 586.922C-12.5323 598.84 -2.8595 608.509 9.07592 608.509C21.0114 608.509 30.6841 598.845 30.6841 586.922C30.6841 575.856 22.3436 566.748 11.6028 565.494C23.3676 564.251 32.5504 554.417 32.7871 542.389C33.0349 553.955 42.4819 563.261 54.1201 563.261C65.7582 563.261 75.475 553.708 75.475 541.927C75.475 530.146 65.9123 520.593 54.1201 520.593C42.3278 520.593 33.0349 529.899 32.7871 541.465C32.6055 531.978 26.8524 523.865 18.6551 520.246C25.4596 517.452 30.7667 511.777 33.0624 504.737C36.2389 513.289 44.4528 519.394 54.1201 519.394C66.5344 519.394 76.5981 509.34 76.5981 496.938C76.5981 484.536 67.4373 475.439 55.8212 474.564C67.5749 473.69 76.8513 463.911 76.8513 451.943C76.8513 439.975 66.6721 429.234 54.1201 429.234C44.6565 429.234 36.5472 435.014 33.1285 443.231C30.8548 436.967 26.2083 431.852 20.2626 428.959C26.4561 425.813 31.13 420.143 32.9523 413.301C35.6829 422.398 44.1225 429.031 54.1201 429.031C66.3308 429.031 76.2237 419.142 76.2237 406.948C76.2237 394.755 66.3253 384.866 54.1201 384.866C44.1225 384.866 35.6884 391.499 32.9523 400.596C30.8273 392.621 24.8265 386.241 17.0696 383.59C25.8835 380.34 32.1815 371.892 32.1815 361.954C32.1815 349.205 21.8372 338.871 9.07594 338.871C-0.872086 338.871 -9.32269 345.163 -12.5818 353.968C-14.9381 347.088 -20.2451 341.604 -26.9946 338.975L-26.9946 608.069C-18.7587 604.576 -12.9837 596.426 -12.9837 586.927L-12.9837 586.922ZM-23.185 383.073C-18.2633 380.092 -14.4701 375.467 -12.5818 369.934C-10.2476 376.248 -5.23778 381.253 1.08227 383.585C-4.45053 385.477 -9.08597 389.261 -12.0643 394.178C-14.5912 389.47 -18.467 385.592 -23.185 383.068L-23.185 383.073ZM-19.7276 428.591C-16.5731 426.226 -13.9416 423.212 -12.0643 419.714C-9.67504 423.652 -6.22872 426.864 -2.10527 428.959C-5.94795 430.829 -9.25113 433.623 -11.723 437.066C-13.7875 433.716 -16.5016 430.829 -19.7276 428.585L-19.7276 428.591ZM-19.2046 474.905C-16.2153 472.722 -13.6719 469.977 -11.723 466.815C-9.37225 470.087 -6.2838 472.777 -2.68336 474.647C-6.44896 476.632 -9.6475 479.542 -11.9817 483.078C-13.826 479.894 -16.2868 477.127 -19.2046 474.911L-19.2046 474.905ZM20.8352 474.647C26.5056 471.71 30.9208 466.716 33.1229 460.649C36.338 468.366 43.6876 473.915 52.4134 474.564C43.4949 475.235 36.0463 481.093 33.0569 489.133C31.0144 482.869 26.5827 477.683 20.8352 474.647ZM-21.7261 520.675C-17.6962 518.261 -14.338 514.862 -11.9817 510.798C-9.20708 514.999 -5.21025 518.316 -0.492234 520.246C-5.73876 522.562 -9.97231 526.725 -12.4001 531.906C-14.36 527.319 -17.6191 523.42 -21.7206 520.675L-21.7261 520.675Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_10116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.126 271.959C216.126 272.096 216.236 272.212 216.374 272.212C216.512 272.212 216.622 272.102 216.622 271.959C216.622 271.816 216.512 271.711 216.374 271.711C216.236 271.711 216.126 271.821 216.126 271.959Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.13 316.954C215.13 317.641 215.691 318.202 216.379 318.202C217.068 318.202 217.629 317.647 217.629 316.954C217.629 316.261 217.068 315.705 216.379 315.705C215.691 315.705 215.13 316.261 215.13 316.954Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.381 361.948C214.381 363.048 215.278 363.945 216.38 363.945C217.481 363.945 218.378 363.048 218.378 361.948C218.378 360.848 217.481 359.952 216.38 359.952C215.278 359.952 214.381 360.843 214.381 361.948Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.88 406.943C213.88 408.323 214.998 409.44 216.38 409.44C217.761 409.44 218.879 408.323 218.879 406.943C218.879 405.562 217.761 404.446 216.38 404.446C214.998 404.446 213.88 405.562 213.88 406.943Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.753 451.938C213.753 453.384 214.926 454.556 216.374 454.556C217.822 454.556 218.995 453.384 218.995 451.938C218.995 450.491 217.822 449.32 216.374 449.32C214.926 449.32 213.753 450.491 213.753 451.938Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.88 496.932C213.88 498.313 214.998 499.429 216.38 499.429C217.761 499.429 218.879 498.313 218.879 496.932C218.879 495.552 217.761 494.441 216.38 494.441C214.998 494.441 213.88 495.557 213.88 496.932Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.254 541.927C214.254 543.098 215.207 544.05 216.379 544.05C217.552 544.05 218.505 543.098 218.505 541.927C218.505 540.756 217.552 539.804 216.379 539.804C215.207 539.804 214.254 540.756 214.254 541.927Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.876 586.922C214.876 587.747 215.548 588.418 216.374 588.418C217.2 588.418 217.871 587.747 217.871 586.922C217.871 586.097 217.2 585.426 216.374 585.426C215.548 585.426 214.876 586.097 214.876 586.922Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.752 631.916C215.752 632.263 216.033 632.538 216.374 632.538C216.715 632.538 216.996 632.257 216.996 631.916C216.996 631.575 216.715 631.295 216.374 631.295C216.033 631.295 215.752 631.575 215.752 631.916Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.341 182.096C171.412 182.096 171.468 182.041 171.468 181.97C171.468 181.898 171.412 181.843 171.341 181.843C171.269 181.843 171.214 181.898 171.214 181.97C171.214 182.041 171.269 182.096 171.341 182.096Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.717 226.964C169.717 227.861 170.444 228.587 171.341 228.587C172.238 228.587 172.965 227.861 172.965 226.964C172.965 226.068 172.238 225.342 171.341 225.342C170.444 225.342 169.717 226.068 169.717 226.964Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.467 271.959C168.467 273.543 169.755 274.83 171.341 274.83C172.926 274.83 174.215 273.543 174.215 271.959C174.215 270.375 172.926 269.088 171.341 269.088C169.755 269.088 168.467 270.37 168.467 271.959Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.344 316.954C167.344 319.159 169.133 320.947 171.341 320.947C173.548 320.947 175.338 319.159 175.338 316.954C175.338 314.748 173.548 312.961 171.341 312.961C169.133 312.961 167.344 314.748 167.344 316.954Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.595 361.948C166.595 364.566 168.72 366.689 171.341 366.689C173.961 366.689 176.086 364.566 176.086 361.948C176.086 359.33 173.961 357.207 171.341 357.207C168.72 357.207 166.595 359.33 166.595 361.948Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.094 406.943C166.094 409.836 168.445 412.184 171.341 412.184C174.237 412.184 176.587 409.841 176.587 406.943C176.587 404.045 174.237 401.702 171.341 401.702C168.445 401.702 166.094 404.05 166.094 406.943Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.847 451.938C165.847 454.968 168.307 457.427 171.341 457.427C174.374 457.427 176.835 454.968 176.835 451.938C176.835 448.907 174.374 446.449 171.341 446.449C168.307 446.449 165.847 448.907 165.847 451.938Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.968 496.932C165.968 499.897 168.374 502.295 171.335 502.295C174.297 502.295 176.703 499.891 176.703 496.932C176.703 493.973 174.297 491.57 171.335 491.57C168.374 491.57 165.968 493.973 165.968 496.932Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.342 541.927C166.342 544.682 168.577 546.921 171.335 546.921C174.093 546.921 176.329 544.688 176.329 541.927C176.329 539.166 174.093 536.939 171.335 536.939C168.577 536.939 166.342 539.172 166.342 541.927Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.091 586.922C167.091 589.265 168.99 591.162 171.335 591.162C173.681 591.162 175.58 589.259 175.58 586.922C175.58 584.584 173.681 582.681 171.335 582.681C168.99 582.681 167.091 584.579 167.091 586.922Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.093 631.916C168.093 633.709 169.546 635.161 171.341 635.161C173.136 635.161 174.589 633.709 174.589 631.916C174.589 630.123 173.136 628.671 171.341 628.671C169.546 628.671 168.093 630.123 168.093 631.916Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.216 676.911C169.216 678.083 170.168 679.034 171.341 679.034C172.513 679.034 173.466 678.083 173.466 676.911C173.466 675.74 172.513 674.788 171.341 674.788C170.168 674.788 169.216 675.74 169.216 676.911Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.713 721.906C170.713 722.252 170.994 722.527 171.335 722.527C171.677 722.527 171.957 722.247 171.957 721.906C171.957 721.565 171.677 721.284 171.335 721.284C170.994 721.284 170.713 721.565 170.713 721.906Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.675 136.98C125.675 137.327 125.956 137.607 126.297 137.607C126.638 137.607 126.919 137.327 126.919 136.98C126.919 136.634 126.638 136.359 126.297 136.359C125.956 136.359 125.675 136.639 125.675 136.98Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.803 181.975C123.803 183.35 124.921 184.472 126.302 184.472C127.684 184.472 128.802 183.356 128.802 181.975C128.802 180.595 127.684 179.478 126.302 179.478C124.921 179.478 123.803 180.595 123.803 181.975Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.179 226.964C122.179 229.239 124.025 231.084 126.302 231.084C128.58 231.084 130.426 229.239 130.426 226.964C130.426 224.689 128.58 222.845 126.302 222.845C124.025 222.845 122.179 224.689 122.179 226.964Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.808 271.959C120.808 274.989 123.269 277.448 126.302 277.448C129.336 277.448 131.796 274.989 131.796 271.959C131.796 268.929 129.336 266.47 126.302 266.47C123.269 266.47 120.808 268.929 120.808 271.959Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.679 316.954C119.679 320.606 122.641 323.565 126.297 323.565C129.952 323.565 132.914 320.606 132.914 316.954C132.914 313.302 129.952 310.343 126.297 310.343C122.641 310.343 119.679 313.302 119.679 316.954Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.683 361.948C118.683 366.15 122.096 369.56 126.302 369.56C130.508 369.56 133.922 366.15 133.922 361.948C133.922 357.746 130.508 354.336 126.302 354.336C122.096 354.336 118.683 357.741 118.683 361.948Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.182 406.943C118.182 411.425 121.816 415.055 126.302 415.055C130.789 415.055 134.423 411.425 134.423 406.943C134.423 402.461 130.789 398.836 126.302 398.836C121.816 398.836 118.182 402.466 118.182 406.943Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.934 451.938C117.934 456.558 121.683 460.297 126.302 460.297C130.921 460.297 134.67 456.558 134.67 451.938C134.67 447.318 130.921 443.578 126.302 443.578C121.683 443.578 117.934 447.318 117.934 451.938Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.183 505.178C130.734 505.243 134.476 501.61 134.542 497.063C134.607 492.516 130.97 488.778 126.419 488.713C121.868 488.648 118.126 492.281 118.061 496.827C117.995 501.374 121.632 505.113 126.183 505.178Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.556 541.927C118.556 546.2 122.025 549.665 126.302 549.665C130.58 549.665 134.043 546.2 134.043 541.927C134.043 537.654 130.574 534.194 126.302 534.194C122.03 534.194 118.556 537.659 118.556 541.927Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.305 586.922C119.305 590.783 122.437 593.907 126.297 593.907C130.156 593.907 133.288 590.777 133.288 586.922C133.288 583.066 130.156 579.937 126.297 579.937C122.437 579.937 119.305 583.066 119.305 586.922Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.434 631.916C120.434 635.156 123.06 637.779 126.302 637.779C129.545 637.779 132.171 635.15 132.171 631.916C132.171 628.682 129.545 626.053 126.302 626.053C123.06 626.053 120.434 628.677 120.434 631.916Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.678 676.911C121.678 679.463 123.748 681.525 126.297 681.525C128.846 681.525 130.916 679.457 130.916 676.911C130.916 674.365 128.846 672.297 126.297 672.297C123.748 672.297 121.678 674.365 121.678 676.911Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.302 721.906C123.302 723.561 124.645 724.898 126.297 724.898C127.948 724.898 129.292 723.556 129.292 721.906C129.292 720.256 127.948 718.914 126.297 718.914C124.645 718.914 123.302 720.256 123.302 721.906Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.053 766.895C125.053 767.582 125.614 768.143 126.302 768.143C126.99 768.143 127.552 767.588 127.552 766.895C127.552 766.202 126.99 765.646 126.302 765.646C125.614 765.646 125.053 766.202 125.053 766.895Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6359 91.9858C80.6359 92.3323 80.9167 92.6128 81.258 92.6128C81.5994 92.6128 81.8801 92.3323 81.8801 91.9858C81.8801 91.6393 81.5994 91.3643 81.258 91.3643C80.9167 91.3643 80.6359 91.6448 80.6359 91.9858Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5165 136.98C78.5165 138.498 79.7442 139.725 81.2636 139.725C82.7831 139.725 84.0107 138.493 84.0107 136.98C84.0107 135.468 82.7831 134.236 81.2636 134.236C79.7442 134.236 78.5165 135.462 78.5165 136.98Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6447 181.975C76.6447 184.527 78.7147 186.59 81.2636 186.59C83.8126 186.59 85.8826 184.522 85.8826 181.975C85.8826 179.429 83.8126 177.361 81.2636 177.361C78.7147 177.361 76.6447 179.429 76.6447 181.975Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7673 226.964C74.7673 230.55 77.6741 233.454 81.2635 233.454C84.853 233.454 87.7598 230.55 87.7598 226.964C87.7598 223.378 84.853 220.48 81.2635 220.48C77.6741 220.48 74.7673 223.384 74.7673 226.964Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.27 271.959C73.27 276.37 76.8484 279.945 81.2637 279.945C85.6789 279.945 89.2573 276.37 89.2573 271.959C89.2573 267.548 85.6789 263.973 81.2637 263.973C76.8484 263.973 73.27 267.548 73.27 271.959Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8936 316.954C71.8936 322.118 76.0886 326.309 81.2581 326.309C86.4275 326.309 90.6226 322.118 90.6226 316.954C90.6226 311.789 86.4275 307.593 81.2581 307.593C76.0886 307.593 71.8936 311.784 71.8936 316.954Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8973 361.948C70.8973 367.668 75.5382 372.305 81.2637 372.305C86.9892 372.305 91.6301 367.668 91.6301 361.948C91.6301 356.228 86.9892 351.592 81.2637 351.592C75.5382 351.592 70.8973 356.228 70.8973 361.948Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2752 406.943C70.2752 413.009 75.1969 417.926 81.2637 417.926C87.3305 417.926 92.2522 413.009 92.2522 406.943C92.2522 400.877 87.3305 395.965 81.2637 395.965C75.1969 395.965 70.2752 400.882 70.2752 406.943Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0219 451.938C70.0219 458.14 75.055 463.168 81.2636 463.168C87.4723 463.168 92.5054 458.14 92.5054 451.938C92.5054 445.735 87.4723 440.707 81.2636 440.707C75.055 440.707 70.0219 445.735 70.0219 451.938Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1484 496.932C70.1484 503.065 75.1251 508.037 81.2635 508.037C87.4019 508.037 92.3787 503.065 92.3787 496.932C92.3787 490.8 87.4019 485.828 81.2635 485.828C75.1251 485.828 70.1484 490.8 70.1484 496.932Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6494 541.927C70.6494 547.784 75.4004 552.531 81.2635 552.531C87.1266 552.531 91.8777 547.784 91.8777 541.927C91.8777 536.07 87.1266 531.323 81.2635 531.323C75.4004 531.323 70.6494 536.07 70.6494 541.927Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1413 596.661C86.5195 596.726 90.9326 592.424 90.9983 587.051C91.064 581.678 86.7574 577.269 81.3792 577.203C76.001 577.138 71.5878 581.44 71.5221 586.813C71.4564 592.186 75.7631 596.595 81.1413 596.661Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.769 631.916C72.769 636.602 76.5732 640.403 81.2637 640.403C85.9542 640.403 89.7583 636.602 89.7583 631.916C89.7583 627.23 85.9542 623.43 81.2637 623.43C76.5732 623.43 72.769 627.23 72.769 631.916Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2664 676.911C74.2664 680.772 77.3989 683.901 81.2581 683.901C85.1173 683.901 88.2498 680.772 88.2498 676.911C88.2498 673.05 85.1173 669.926 81.2581 669.926C77.3989 669.926 74.2664 673.056 74.2664 676.911Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.017 721.906C76.017 724.8 78.3659 727.147 81.2635 727.147C84.1611 727.147 86.51 724.8 86.51 721.906C86.51 719.011 84.1611 716.664 81.2635 716.664C78.3659 716.664 76.017 719.011 76.017 721.906Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.889 766.895C77.889 768.754 79.3974 770.266 81.2637 770.266C83.13 770.266 84.6384 768.759 84.6384 766.895C84.6384 765.03 83.13 763.523 81.2637 763.523C79.3974 763.523 77.889 765.03 77.889 766.895Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8873 811.889C79.8873 812.648 80.5038 813.264 81.2636 813.264C82.0233 813.264 82.6399 812.648 82.6399 811.889C82.6399 811.131 82.0233 810.52 81.2636 810.52C80.5038 810.52 79.8873 811.136 79.8873 811.889Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2249 47.1121C36.2965 47.1121 36.3516 47.0571 36.3516 46.9856C36.3516 46.9141 36.2965 46.8591 36.2249 46.8591C36.1534 46.8591 36.0983 46.9141 36.0983 46.9856C36.0983 47.0571 36.1534 47.1121 36.2249 47.1121Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7256 91.9858C33.7256 93.3663 34.8431 94.4827 36.225 94.4827C37.6068 94.4827 38.7244 93.3663 38.7244 91.9858C38.7244 90.6053 37.6068 89.4943 36.225 89.4943C34.8431 89.4943 33.7256 90.6108 33.7256 91.9858Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6061 136.98C31.6061 139.532 33.6761 141.595 36.2251 141.595C38.774 141.595 40.844 139.527 40.844 136.98C40.844 134.434 38.774 132.366 36.2251 132.366C33.6761 132.366 31.6061 134.434 31.6061 136.98Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4811 181.975C29.4811 185.699 32.498 188.713 36.225 188.713C39.9521 188.713 42.969 185.699 42.969 181.975C42.969 178.252 39.9521 175.238 36.225 175.238C32.498 175.238 29.4811 178.252 29.4811 181.975Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4825 226.964C27.4825 231.788 31.3968 235.698 36.2249 235.698C41.053 235.698 44.9673 231.788 44.9673 226.964C44.9673 222.141 41.053 218.23 36.2249 218.23C31.3968 218.23 27.4825 222.141 27.4825 226.964Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7319 271.959C25.7319 277.745 30.4279 282.442 36.225 282.442C42.022 282.442 46.718 277.75 46.718 271.959C46.718 266.168 42.022 261.476 36.225 261.476C30.4279 261.476 25.7319 266.168 25.7319 271.959Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2603 317.322C24.4591 323.934 29.9861 329.134 36.6053 328.935C43.2245 328.737 48.4293 323.215 48.2305 316.603C48.0317 309.99 42.5047 304.79 35.8855 304.989C29.2664 305.187 24.0616 310.709 24.2603 317.322Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1115 361.948C23.1115 369.186 28.9801 375.049 36.2251 375.049C43.47 375.049 49.3386 369.186 49.3386 361.948C49.3386 354.71 43.47 348.848 36.2251 348.848C28.9801 348.848 23.1115 354.71 23.1115 361.948Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3626 406.943C22.3626 414.593 28.5671 420.792 36.2249 420.792C43.8827 420.792 50.0872 414.593 50.0872 406.943C50.0872 399.293 43.8827 393.094 36.2249 393.094C28.5671 393.094 22.3626 399.293 22.3626 406.943Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.683 466.029C43.47 466.327 50.0251 460.263 50.3243 452.484C50.6234 444.704 44.5533 438.156 36.7663 437.857C28.9793 437.558 22.4242 443.622 22.1251 451.402C21.8259 459.181 27.896 465.73 35.683 466.029Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2361 496.932C22.2361 504.649 28.5011 510.908 36.225 510.908C43.9489 510.908 50.2139 504.649 50.2139 496.932C50.2139 489.216 43.9489 482.957 36.225 482.957C28.5011 482.957 22.2361 489.216 22.2361 496.932Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8636 541.927C22.8636 549.302 28.8478 555.275 36.2249 555.275C43.602 555.275 49.5862 549.297 49.5862 541.927C49.5862 534.557 43.602 528.579 36.2249 528.579C28.8478 528.579 22.8636 534.557 22.8636 541.927Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7934 599.238C42.618 599.48 48.3474 594.15 48.5905 587.332C48.8336 580.514 43.4983 574.79 36.6737 574.548C29.8491 574.305 24.1196 579.635 23.8765 586.453C23.6334 593.271 28.9688 598.995 35.7934 599.238Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2366 631.916C25.2366 637.983 30.1583 642.894 36.2251 642.894C42.2919 642.894 47.2136 637.977 47.2136 631.916C47.2136 625.855 42.2919 620.939 36.2251 620.939C30.1583 620.939 25.2366 625.855 25.2366 631.916Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8604 676.911C26.8604 682.081 31.0554 686.272 36.2249 686.272C41.3943 686.272 45.5894 682.081 45.5894 676.911C45.5894 671.741 41.3943 667.556 36.2249 667.556C31.0554 667.556 26.8604 671.747 26.8604 676.911Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7322 721.906C28.7322 726.04 32.0868 729.391 36.2249 729.391C40.363 729.391 43.7175 726.04 43.7175 721.906C43.7175 717.772 40.363 714.42 36.2249 714.42C32.0868 714.42 28.7322 717.772 28.7322 721.906Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8519 766.895C30.8519 769.859 33.2577 772.263 36.2195 772.263C39.1814 772.263 41.5872 769.859 41.5872 766.895C41.5872 763.93 39.1814 761.532 36.2195 761.532C33.2577 761.532 30.8519 763.936 30.8519 766.895Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9769 811.889C32.9769 813.682 34.4303 815.134 36.225 815.134C38.0198 815.134 39.4731 813.682 39.4731 811.889C39.4731 810.097 38.0198 808.645 36.225 808.645C34.4303 808.645 32.9769 810.097 32.9769 811.889Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3497 856.884C35.3497 857.368 35.7405 857.759 36.225 857.759C36.7095 857.759 37.1003 857.368 37.1003 856.884C37.1003 856.4 36.7095 856.01 36.225 856.01C35.7405 856.01 35.3497 856.4 35.3497 856.884Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.6811 226.964C-19.6811 232.959 -14.8144 237.821 -8.81369 237.821C-2.81294 237.821 2.05371 232.965 2.05371 226.964C2.05371 220.964 -2.81294 216.107 -8.81369 216.107C-14.8144 216.107 -19.6811 220.969 -19.6811 226.964Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.5529 271.959C-21.5529 278.988 -15.8494 284.686 -8.81365 284.686C-1.77792 284.686 3.92554 278.988 3.92554 271.959C3.92554 264.93 -1.77791 259.232 -8.81365 259.232C-15.8494 259.232 -21.5529 264.93 -21.5529 271.959Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.3035 316.954C-23.3035 324.948 -16.8161 331.429 -8.81361 331.429C-0.811073 331.429 5.67627 324.948 5.67627 316.954C5.67627 308.959 -0.811071 302.478 -8.81361 302.478C-16.8161 302.478 -23.3035 308.959 -23.3035 316.954Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.5474 362.594C-24.1865 371.267 -16.8557 378.007 -8.17348 377.646C0.508709 377.286 7.25447 369.962 6.89362 361.288C6.53276 352.614 -0.798062 345.875 -9.48025 346.236C-18.1624 346.596 -24.9082 353.92 -24.5474 362.594Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.4231 406.943C-25.4231 416.106 -17.9855 423.536 -8.81374 423.536C0.358042 423.536 7.79565 416.106 7.79565 406.943C7.79565 397.78 0.358043 390.35 -8.81374 390.35C-17.9855 390.35 -25.4231 397.78 -25.4231 406.943Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.7974 451.938C-25.7974 461.309 -18.1946 468.905 -8.8136 468.905C0.567383 468.905 8.17016 461.309 8.17017 451.938C8.17017 442.566 0.567385 434.97 -8.8136 434.97C-18.1946 434.97 -25.7974 442.566 -25.7974 451.938Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.6763 496.932C-25.6763 506.238 -18.1286 513.778 -8.81368 513.778C0.501237 513.778 8.04346 506.238 8.04346 496.932C8.04346 487.626 0.495733 480.092 -8.81368 480.092C-18.1231 480.092 -25.6763 487.632 -25.6763 496.932Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.9219 541.927C-24.9219 550.815 -17.71 558.02 -8.81351 558.02C0.0830107 558.02 7.29492 550.815 7.29492 541.927C7.29492 533.039 0.0830121 525.834 -8.81351 525.834C-17.71 525.834 -24.9219 533.039 -24.9219 541.927Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.6367 587.122C-23.5336 595.323 -16.7955 601.887 -8.5869 601.784C-0.378262 601.681 6.19253 594.95 6.08937 586.749C5.98621 578.549 -0.75183 571.984 -8.96047 572.087C-17.1691 572.19 -23.7399 578.922 -23.6367 587.122Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.175 631.916C-22.175 639.292 -16.1907 645.265 -8.81368 645.265C-1.43662 645.265 4.54761 639.286 4.54761 631.916C4.54761 624.546 -1.43662 618.568 -8.81368 618.568C-16.1907 618.568 -22.175 624.546 -22.175 631.916Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.3032 676.911C-20.3032 683.252 -15.1613 688.389 -8.81372 688.389C-2.46614 688.389 2.67578 683.252 2.67578 676.911C2.67578 670.57 -2.46614 665.433 -8.81372 665.433C-15.1613 665.433 -20.3032 670.57 -20.3032 676.911Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-18.3047 721.906C-18.3047 727.142 -14.0546 731.387 -8.81359 731.387C-3.57257 731.387 0.67749 727.142 0.67749 721.906C0.67749 716.67 -3.57257 712.424 -8.81359 712.424C-14.0546 712.424 -18.3047 716.67 -18.3047 721.906Z",
    fill: "#F26A25",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_10116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 947,
    height: 399,
    fill: "white",
    transform: "translate(372) rotate(90)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_10116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 947,
    height: 399,
    fill: "white",
    transform: "translate(219) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftColumnDottedBackground);
export default __webpack_public_path__ + "static/media/left-column-dotted-background.6fedad331b66b81a523f3f5f4242f2e9.svg";
export { ForwardRef as ReactComponent };